import React from 'react';
import { Link, useNavigate } from 'react-router-dom';

const NotFound: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="container-fixed">
      <div className="flex flex-col items-center justify-center min-h-[500px] text-center">
        <div className="mb-6">
          <i className="ki-filled ki-information-5 text-6xl text-gray-400"></i>
        </div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">
          404 - Page Not Found
        </h1>
        <p className="text-gray-600 mb-8 max-w-md">
          The page you're looking for doesn't exist. It may have been moved or deleted.
        </p>
        <div className="flex gap-3">
          <button
            onClick={() => navigate(-1)}
            className="btn btn-light"
          >
            <i className="ki-filled ki-left mr-2"></i>
            Go Back
          </button>
          <Link to="/" className="btn btn-primary">
            <i className="ki-filled ki-home-2 mr-2"></i>
            Go to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;